import { render, staticRenderFns } from "./ProyekDetail.vue?vue&type=template&id=2cb4f3b3&scoped=true&"
import script from "./ProyekDetail.vue?vue&type=script&lang=js&"
export * from "./ProyekDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProyekDetail.vue?vue&type=style&index=0&id=2cb4f3b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb4f3b3",
  null
  
)

export default component.exports